import appmixer from '../../plugins/appmixer';

export default class StatusRequests {
    getStatus() {
        return appmixer.api.request({
            url: appmixer.api.get('baseUrl'),
            method: 'GET'
        });
    }
};
